<template>
  <div style="height: 100%;">
    <earth :graphics="graphics" :fan="fan" @clickViewer="clickViewer" :zoomToFirstGraphic="zoomToFirstGraphic"></earth>
    <plan
      :planId="planId"
      :cityId="cityId"
      :simple="simple"
      :plans="plans"
      :turbine="turbine"
      :tower="tower"
      :windfarm="windfarm"
      :projectItem="projectItem"
      :heightList="dataSet.datasetHeight"
      @planChange="planChange"
      @updateImg="updateImg"
      @clearImg="clearImg"
      @heightChange="heightChange"
    />
  </div>
</template>
<script>
import isEmpty from 'lodash/isEmpty';
import Earth from '@/earth';
import { setEarthCenter } from '@/earth/utils';
import fetch from '@/utils/fetch';
import { getToken, safeParse } from '@/utils';
import Plan from './components/plan';

export default {
  components: {
    Earth,
    Plan
  },
  data() {
    return {
      // scene: window.URL_CONFIG.SCENE_OLYMPIC_GREEN,
      // scene: `${process.env.VUE_APP_URL}/3d/`,
      zoomToFirstGraphic: true,
      graphics: null,
      fan: null,
      plans: [],
      planId: '',
      cityId: '',
      simple: [],
      windfarm: [],
      turbine: null,
      tower: null,
      dataSet: { datasetHeight: [] }
      // fan: [
      //   [116.400772400405, 40.022863398376, 12.9858561288565],
      //   [116.399490142569, 40.022585773106, 13.9601957760751],
      //   [116.399620317977, 40.0242508926839, 14.8174676615745],
      //   [116.40160598615, 40.0221184739456, 13.3167685521767]
      // ],
      // markers: [
      // [116.400772400405, 40.022863398376, 12.9858561288565],
      // [116.399490142569, 40.022585773106, 13.9601957760751],
      // [116.399620317977, 40.0242508926839, 14.8174676615745],
      // [116.40160598615, 40.0221184739456, 13.3167685521767]
      // ],
      // polygons: [
      // [
      //   [116.400772400405, 40.0],
      //   [116.399490142569, 39.9],
      //   [116.399490142569, 39.9],
      //   [116.399490142569, 39.85],
      //   [116.41, 40.0]
      // ]
      // ]
    };
  },
  async mounted() {
    if (!this.$route.query.projectId) {
      this.$message.error('项目id不能为空');
      return;
    }
    this.getDataSet();
    await Promise.all([this.getGraphics()]);
    this.getEnergyTurbineList();
  },
  computed: {
  },
  methods: {
    /** 获取风资源 */
    async getItems() {
      try {
        const res = await fetch({
          url: '/windfarm/project/getUserItemList',
          method: 'get',
          params: {
            apiKey: getToken(),
            projectId: this.$route.query.projectId
          },
          showError: true
        });
        const markers = [];
        // 蓝色的面
        const polygons = [];
        (res?.data?.itemList || []).forEach(item => {
          const arr = safeParse(item.geometryInfo)?.coordinates;
          if (isEmpty(arr)) return;
          if (item.itemType === 1) {
            // 经、纬度
            markers.push({
              type: 'default',
              coordinates: [arr[0], arr[1]]
            });
            return;
          }
          arr.forEach(arrItem => {
            arrItem.forEach(it => {
              polygons.push({
                // id: item.itemId,
                type: 'exclusive',
                isdefault: item.isdefault,
                coordinates: it
              });
            });
          });
          if (item.isdefault) {
            this.cityId = item.adcode;
          }
        }) || [];
        return { markers, polygons };
      } catch (e) {
        console.log(e);
        return { markers: [], polygons: [] };
      }
    },
    /** 获取项目风场，黄色的面 */
    async getProjectInfo() {
      try {
        const res = await fetch({
          url: '/windfarm/project/getProjectById',
          method: 'get',
          params: {
            apiKey: getToken(),
            projectId: this.$route.query.projectId
          },
          showError: true
        });
        const projectItem = res?.data?.projectInfo;
        this.projectItem = projectItem;

        if (projectItem?.data?.projectInfo) {
          setEarthCenter({
            lat: projectItem?.data?.projectInfo.lat,
            lon: projectItem?.data?.projectInfo.lon
          });
        }

        if (this.$route.query.planId) {
          this.planId = +this.$route.query.planId;
        }
        if (!isEmpty(projectItem?.data?.planList)) {
          this.plans = projectItem?.data?.planList;
          if (!this.planId) {
            this.planId = +projectItem?.data?.planList[0].planId;
          }
        }

        const info = safeParse(projectItem?.data?.projectInfo?.geometryInfo);
        const polygons = [];
        if (info?.coordinates) {
          info.coordinates.forEach(item => {
            polygons.push({
              type: 'windfarm',
              coordinates: item
            });
          });
        }
        return polygons;
      } catch (e) {
        return [];
      }
    },
    /** 获取敏感因素，蓝色的面 */
    async getWindfarmExclusive() {
      try {
        const res = await fetch({
          url: '/windfarm/project/getWindfarmExclusive',
          method: 'get',
          params: {
            apiKey: getToken(),
            projectId: this.$route.query.projectId
          },
          showError: true
        });
        const list = res?.data?.exclusiveList || [];
        const polygons = [];
        list.forEach(item => {
          const info = safeParse(item.geometryInfo);
          if (info?.coordinates) {
            info.coordinates.forEach(item => {
              polygons.push({
                type: 'exclusive',
                coordinates: item
              });
            });
          }
        });
        return polygons;
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    /** 获取测风塔 */
    async getTowerList() {
      try {
        if (!this.planId) return [];
        const res = await fetch({
          url: '/windfarm/station/getRecommendTowerList',
          method: 'get',
          params: {
            apiKey: getToken(),
            planId: this.planId
          },
          showError: true
        });
        this.towerMap = {};
        const result = [];
        const list = res?.data?.towerList || [];
        list.forEach(item => {
          const id = `tower_${item.towerNo}`;
          result.push({
            id,
            type: 'tower',
            coordinates: [item.lon, item.lat]
          });
          this.towerMap[id] = item;
        });
        return result;
      } catch (e) {
        return [];
      }
    },
    /** 获取风机 */
    async getPlanTurbineList() {
      try {
        if (!this.planId) return [];
        const res = await fetch({
          url: '/windfarm/station/getPlanTurbineList',
          method: 'get',
          params: {
            apiKey: getToken(),
            planId: this.planId
          },
          showError: true
        });
        const result = [];
        const list = res?.data?.turbineList || [];
        list.forEach(item => {
          result.push({
            id: `turbine_${item.turbineId}`,
            type: 'turbine',
            coordinates: [item.lon, item.lat]
          });
        });
        return result;
      } catch (e) {
        return [];
      }
    },
    async getGraphics() {
      const windfarm = await this.getProjectInfo();
      const [exclusive, userItems, towers, turbines] = await Promise.all([
        this.getWindfarmExclusive(),
        this.getItems(),
        this.getTowerList(),
        this.getPlanTurbineList()
      ]);
      this.towers = towers;
      this.turbines = turbines;
      this.windfarm = windfarm;
      this.exclusive = exclusive;
      this.userItems = userItems;
      this.setGraphics();
      console.log('this.graphics', this.graphics);
    },
    async getEnergyTurbineList() {
      try {
        if (!this.planId) return [];
        const res = await fetch({
          url: '/windfarm/station/getEnergyTurbineList',
          method: 'get',
          params: {
            apiKey: getToken(),
            planId: this.planId
          },
          showError: true
        });
        this.turbineMap = (res?.data?.turbineList || []).reduce(
          (acc, turbine) => {
            acc[`turbine_${turbine.turbineId}`] = turbine;
            return acc;
          },
          {}
        );
      } catch (e) {console.log(e)}
    },
    updateImg(img) {
      this.zoomToFirstGraphic = false;
      this.img = img;
      this.setGraphics();
    },
    clearImg() {
      this.img = null;
      this.setGraphics(true);
    },
    async planChange(planId) {
      this.planId = planId;
      const [towers, turbines] = await Promise.all([
        this.getTowerList(),
        this.getPlanTurbineList()
      ]);
      this.towers = towers;
      this.turbines = turbines;
      this.setGraphics();
      this.getEnergyTurbineList();
    },
    setGraphics() {
      const { windfarm, towers, turbines, img } = this;
      const { polygons } = this.userItems;
      const graphics = {
        // polygons: [...polygons, ...exclusive],
        polygons: [],
        polylines: [...windfarm],
        // markers: [...towers]
        markers: [...turbines, ...towers]
      };
      const defaultGons = polygons
        .filter(item => item.isdefault === 1)
        .map(item => {
          return {
            ...item
            // id: `polyline_${item.id}`
          };
        });
      if (!isEmpty(defaultGons)) {
        graphics.polylines.push(...defaultGons);
      }
      if (img) {
        graphics.polygons.push(
          ...defaultGons.map(item => {
            return {
              ...item,
              image: img.url
              // id: `polygon_${item.id}`
            };
          })
        );
      }
      console.log('this.graphics', this.graphics);
      this.graphics = graphics;
    },
    async clickViewer(data) {
      if (!data) return;
      if (data.indexOf('turbine') !== -1) {
        this.turbine = this.turbineMap[data];
        this.tower = null;
        console.log('click', data, this.turbine);
      } else if (data.indexOf('tower') !== -1) {
        this.tower = await this.getWindSummaryData(this.towerMap[data]);
        this.turbine = null;
        console.log('click', data, this.tower);
      }
    },
    async getDataSet() {
      const res = await this.$fetch('/windfarm/project/getDataSet');
      const { data = {} } = res;
      const { dataSet = [] } = data;
      this.dataSet = dataSet[0] || { datasetHeight: [] };
    },
    heightChange(height) {
      this.datasetHeight = height;
      this.tower = this.getWindSummaryData(this.tower);
    },
    async getWindSummaryData(item) {
      const dataSet = this.dataSet;
      const params = {
        lat: item.lat,
        lon: item.lon,
        datasetCode: dataSet.datasetCode,
        datasetHeight: this.datasetHeight || dataSet.datasetHeight[0],
      };
      const res = await this.$fetch('/windfarm/meso/point/getWindSummaryData', {
        showError: true,
        params,
      });
      const { data = {} } = res;
      data.lat = item.lat;
      data.lon = item.lon;
      return data;
    }
  }
};
</script>
